<template>
 <div class="dateView-Container">
   <!--
   <div class="view-header">
      <div class="view-header-left" :class="{'view-header-choose':isA}" @click="changeType1">
        <p>{{$t('RealTime')}}</p>
      </div>
      <div class="view-header-right" :class="{'view-header-choose':isB}" @click="changeType2">
        <p>{{$t('Uploaded')}}</p>
      </div>
   </div>-->

   <!--<button v-show="isB" @click="set2">{{$t('save')}}</button>-->
   <button  @click="set2">{{$t('Back')}}</button>
   <div class="view-main" v-show="isA">
     <img src="../../assets/Real-time.png">

   </div>

   <div class="view-main2" v-show="isB">
     <div class="main-header-left">
       <span>{{$t('sensor')}}</span>
       <span style="color:#ff3c3c" v-show="isLapp1">{{$t('overLapp')}}:{{LapList1}}</span>
     </div>

     <div v-if="haveSensorData">
       <div class="header">
         <table>
           <tr class="table-title">
             <td style="width:52px">{{$t('t1112_Number')}}</td>
             <!--<td class="checkbox"><input type="checkbox" class="checkbox22" id="checkbox1"><label @click="choose" for="checkbox1" :class="{'checked':isC}" id="all1"></label></td>-->
             <td class="spe-td1">{{$t('tranSn')}}</td> <td class="spe-td2">{{$t('pdmSN')}}</td>
             <td class="spe-td3">{{$t('startTime')}}</td> <td class="spe-td4">{{$t('endTime')}}</td> <td>{{$t('UploadTime')}}</td>
           </tr>
         </table>
       </div>
       <div class="table-container">
         <table id="table1">
          <tr v-for="(item,index) in Sessions[0]" :class="(index%2===0) ? '':'even'" :id="'lap'+index">
            <td style="width:54px">{{index+1}}</td>
            <!--<td class="checkbox" :id="index"><input type="checkbox" class="checkbox22"><label @click="select(0,$event)"></label></td>-->
            <td class="spe-td1">{{item[1]}}</td> <td>{{item[6]}}</td> <td>{{item[3]}}</td> <td>{{item[4]}}</td><td>{{item[5]}}</td>
          </tr>
         </table>
       </div>
     </div>
     <div v-else>
       <div class="no-data">
         <p>{{$t('No data')}}</p>
       </div>
     </div>

     <div class="main-header-left pdm">
       <span>{{$t('Patch Pump')}}</span>
       <span style="color:#ff3c3c" v-show="isLapp2">{{$t('overLapp')}}:{{LapList2}}</span>
     </div>

     <div v-if="havePumpData">
       <div class="header">
         <table>
           <tr class="table-title">
             <td style="width:52px">{{$t('t1112_Number')}}</td>
             <!--<td class="checkbox"><input type="checkbox" class="checkbox22" id="checkbox8"><label @click="choose2" for="checkbox1" :class="{'checked':isK}" id="all2"></label></td>-->
             <td class="spe-td1">{{$t('pumpSN')}}</td> <td class="spe-td2">{{$t('pdmSN')}}</td>
             <td class="spe-td3">{{$t('startTime')}}</td> <td class="spe-td4">{{$t('endTime')}}</td> <td>{{$t('UploadTime')}}</td>
           </tr>
         </table>
       </div>
       <div class="table-container">
         <table id="table2">
           <tr v-for="(item,index) in Sessions[1]" :class="(index%2===0) ? '':'even'" :id="'lapp'+index">
             <td style="width:54px">{{index+1}}</td>
             <!--<td class="checkbox" :id ="index"><input type="checkbox" class="checkbox22"><label  @click="select(1,$event)"></label></td>-->
             <td class="spe-td1">{{item[1]}}</td> <td>{{item[6]}}</td> <td>{{item[3]}}</td> <td>{{item[4]}}</td><td>{{item[5]}}</td>
           </tr>
         </table>
       </div>
     </div>
     <div v-else>
       <div class="no-data">
         <p>{{$t('No data')}}</p>
       </div>
     </div>


   </div>
<!--
   <div class="central-btn-container" v-show="isP">
     <button class="data-delete" :class="{}" @click="deleteData">
       <span>{{$t('Delete Data')}}</span>
     </button>
   </div>-->
 </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default{
    data(){
      return{
        Sessions:'',overLapp1:[],overLapp2:[],isLapp1:false,isLapp2:false,LapList1:'',LapList2:'',
        isA:'',isB:'',
        isC:false,
        isP:'',
        isK:false,flag:0,flag1:0, uid:0,cgms:[],pump:[],set:[],isZh:false,
        haveSensorData:false,
        havePumpData:false,
      }
    },
    created(){
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      auth.getSet(this,this.uid);
      auth.getSessions(this,this.uid);
    },
    mounted:function () {
     /* if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      auth.getSet(this,this.uid);*/
      if(!sessionStorage.getItem('dateViewA')){
         // this.isA = true;
         // this.isB = false;
      }
      else{
        this.isA = sessionStorage.getItem('dateViewA')==='1'? true:false;
        this.isB = sessionStorage.getItem('dateViewB')==='1'? true:false;
      }
     // auth.getSessions(this,this.uid);
      let lang = sessionStorage.getItem('language');
      this.isZh = (lang==='zh')?true:false;
      this.isP=(sessionStorage.getItem('userType')==='P');
    },
    methods:{
      changeType1(){
        this.isA = true;
        this.isB = false;
        this.set1();
        this.initSet();
        sessionStorage.setItem('dateViewA',1);
        sessionStorage.setItem('dateViewB',0);
      },
      changeType2(){
        this.isB = true;
        this.isA = false;
      },
      deleteData() {
        let tip = this.$t('deleteData');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Delete');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(() => {
          //auth.deleteEvents(this,this.uid,this.eids);
          auth.deleteData(this);
        },function () {

        });
      },
      choose(){
        this.isC = !this.isC;
        const table1  = document.getElementById('table1');
        const labels = table1.getElementsByTagName('label');
        for(let i=0;i<labels.length;i++){
            if(this.flag===0){
              labels[i].className = 'checked';
            }else{
              labels[i].className = '';
            }
        }
        //判断下一次点击是全选还是全不选
        if(labels[0].className==='checked'){this.flag = 1;}
        else{ this.flag = 0;}
        this.checkOverLapp();
      },
      select(flag,e){
        let index = e.target.parentNode.id;
        let id =0;
        if(e.target.className===''){
          e.target.className = 'checked';
        }else{
          e.target.className = '';
        }
        this.checkOverLapp();
      },
      choose2(){
        this.isK = !this.isK;
        const table2  = document.getElementById('table2');
        const labels = table2.getElementsByTagName('label');
        for(let i=0;i<labels.length;i++){
          if(this.flag1===0){
            labels[i].className = 'checked';
          }else{
            labels[i].className = '';
          }
        }
        if(labels[0].className==='checked'){ this.flag1 = 1;}
        else{ this.flag1 = 0;}
        //console.log(labels.length,this.pump);
        this.checkOverLapp();
      },
      set1(){
         let data = {
           option:'daopapp',
           cgms:[],
           pump:[],
         } ;
         auth.setData(this,this.uid,{data:data});
      },
      set2(){
        if (0) {
          /*//this.checkData();
          if(this.isLapp1||this.isLapp2){
            let tip = this.$t('Time overlapped');
            this.$message.error(tip);
          }else{
            let data = {
              option:'daoppdm',
              cgms:this.cgms,
              pump:this.pump,
            } ;
            if(this.cgms.length===0&&this.pump.length===0){
              let tip =this.$t('selectData');
              this.$message.error(tip);
            }else{
              auth.setData(this,this.uid,{data:data});
              sessionStorage.setItem('dateViewA',0);
              sessionStorage.setItem('dateViewB',1);
            }
          }*/
        }
        this.$router.push('/dateView2');
      },
      checkData(){
        this.cgms =[];
        this.pump = [];
        const table1  = document.getElementById('table1');
        const labels1 = table1.getElementsByTagName('label');
        for(let i=0;i<labels1.length;i++){
            if(labels1[i].className=== 'checked'){
              let id = this.Sessions[0][i][2];
              this.cgms.push(id);
            }
        }
        const table2  = document.getElementById('table2');
        const labels2= table2.getElementsByTagName('label');
        for(let i=0;i<labels2.length;i++){
            if(labels2[i].className ==='checked'){
              let id = this.Sessions[1][i][2];
              this.pump.push(id);
            }
        }

        if(this.cgms.length===this.Sessions[0].length){
          this.isC = true;
          this.flag = 1;
        }else{
          this.isC = false;
          this.flag = 0;
        }
        if(this.pump.length===this.Sessions[1].length){
          this.isK = true;
          this.flag1 = 1;
        }else{
          this.isK = false;
          this.flag1 = 0;
        }
      },
      checkOverLapp(){
        this.checkData();
        let cgm = [],p=0;
        this.isLapp1 =false;
        this.LapList1=' ';
        this.initSession1();
        if(this.cgms.length>0){
          for(let i=0;i<this.cgms.length;i++){
                for(let j=0;j<this.Sessions[0].length;j++){
                    if(this.cgms[i]===this.Sessions[0][j][2]){
                      cgm[p]=[];
                      cgm[p][0] = j+1;
                      cgm[p][1] = this.Sessions[0][j][3];
                      cgm[p][2] = this.Sessions[0][j][4];
                      p++;
                    }
                }
            }
          this.forMatter(cgm);
          //console.log(cgm);
          this.overLapp1 = this.getOverLapp(cgm);
          if(this.overLapp1.length>0){
              let tips = 0;
              if(this.overLapp1.length<11){
                tips = this.overLapp1.length;
              }else{
                tips=10;
              }
            for(let i=0;i<tips;i++){
              this.LapList1 += this.overLapp1[i][0]+' and '+this.overLapp1[i][1]+'; ';
              this.isLapp1 =true;
              let id1 = 'lap'+ (this.overLapp1[i][0]-1);
              let tr1 = document.getElementById(id1);
              tr1.style.color ="#f00";
              let id2 = 'lap'+ (this.overLapp1[i][1]-1);
              let tr2 = document.getElementById(id2);
              tr2.style.color ="#f00";
            }
          }
          //console.log(this.overLapp1);
        }
        let pump = [],k=0;
        this.isLapp2 =false;
        this.LapList2=' ';
        this.initSession2();
        if(this.pump.length>0){
          for(let i=0;i<this.pump.length;i++){
            for(let j=0;j<this.Sessions[1].length;j++){
              if(this.pump[i]===this.Sessions[1][j][2]){
                pump[k]=[];
                pump[k][0] = j+1;
                pump[k][1] = this.Sessions[1][j][3];
                pump[k][2] = this.Sessions[1][j][4];
                k++;
              }
            }
          }
          this.forMatter(pump);
          this.overLapp2 = this.getOverLapp(pump);
          //console.log(this.overLapp2);
          if(this.overLapp2.length>0){
            let tips = 0;
            if(this.overLapp2.length<11){
              tips = this.overLapp2.length;
            }else{
              tips=10;
            }
            for(let i=0;i<tips;i++){
              this.LapList2 += this.overLapp2[i][0]+' and '+this.overLapp2[i][1]+'; ';
              this.isLapp2 =true;
              let id1 = 'lapp'+ (this.overLapp2[i][0]-1);
              let tr1 = document.getElementById(id1);
              tr1.style.color ="#f00";
              let id2 = 'lapp'+ (this.overLapp2[i][1]-1);
              let tr2 = document.getElementById(id2);
              tr2.style.color ="#f00";
            }
          }
        }
        //console.log(this.Sessions);
      },
      forMatter(val){
          let that =this;
          val.map(function (e,i) {
            let t1 = e[1].split(' ');
            let t11 = t1[0].split('-');
            e[1] = (that.isZh)? Date.parse(t11[0]+'/'+t11[1]+'/'+t11[2]+' '+t1[1])/1000:Date.parse(t11[2]+'/'+t11[1]+'/'+t11[0]+' '+t1[1])/1000;

            let t2 = e[2].split(' ');
            let t21 = t2[0].split('-');
            e[2] = (that.isZh)?Date.parse(t21[0]+'/'+t21[1]+'/'+t21[2]+' '+t2[1])/1000:Date.parse(t21[2]+'/'+t21[1]+'/'+t21[0]+' '+t2[1])/1000;
            return e;
          })
      },
      getOverLapp(val){
        let over =[],p=0;
        for(let i=0;i<val.length-1;i++){
              for(let j=i+1;j<val.length;j++){
                  if(val[i][1]>val[j][2]||val[i][2]<val[j][1]){
                      continue;
                  }else{
                     over[p] = [];
                     over[p][0] = val[i][0];
                     over[p][1] = val[j][0];
                     p++;
                  }
              }
        }
        return over;
      },
      initSession1(){
        for(let i=0;i<this.Sessions[0].length;i++){
          let id1 = 'lap'+ i;
          let tr1 = document.getElementById(id1);
          tr1.style.color ="#282828";
        }
      },
      initSession2(){
        for(let i=0;i<this.Sessions[1].length;i++){
          let id1 = 'lapp'+ i;
          let tr1 = document.getElementById(id1);
          tr1.style.color ="#282828";
        }
      },
      back(){
        this.$router.push('/PatientList');
      },
      checkSet(){
        return;
        const table1  = document.getElementById('table1');
        const labels = table1.getElementsByTagName('label');
        if(this.cgms){
          for(let i=0;i<this.cgms.length;i++){
            let id = this.cgms[i];
            for(let j=0;j<this.Sessions[0].length;j++){
              if(id ===this.Sessions[0][j][2]){
                labels[j].className = 'checked';
              }
            }
          }
          if(this.cgms.length===this.Sessions[0].length){
            let all =  document.getElementById('all1');
            all.className = 'checked';
          }
        }
        if(this.pump){
          const table2  = document.getElementById('table2');
          const labels2 = table2.getElementsByTagName('label');
          for(let i=0;i<this.pump.length;i++){
            let id = this.pump[i];
            for(let j=0;j<this.Sessions[1].length;j++){
              if(id ===this.Sessions[1][j][2]){
                labels2[j].className = 'checked';
              }
            }
          }
          if(this.pump.length===this.Sessions[1].length){
            let all =  document.getElementById('all2');
            all.className = 'checked';
          }
         }
      },
      initSet(){
        return;
        const table1  = document.getElementById('table1');
        const labels1 = table1.getElementsByTagName('label');
        let all =  document.getElementById('all1');
        all.className = '';
        let all2 =  document.getElementById('all2');
        all2.className = '';
        for(let i=0;i<labels1.length;i++){
          labels1[i].className= '';
        }
        const table2  = document.getElementById('table2');
        const labels2= table2.getElementsByTagName('label');
        for(let i=0;i<labels2.length;i++){
          labels2[i].className= '';
        }
      },
    },
  }
</script>

<style scoped>
  .dateView-Container{
    height:100%;
    width:100%;
    margin:0 auto;
    font-family:SFUIText-Regular;
  }
  @media screen and (min-height: 950px){
    .dateView-Container{
      min-height:700px;
    }
  }
  .view-header{
    width:33%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#0076ff;
    letter-spacing:-0.1px;
    text-align:center;
  }
  .view-header-left,.view-header-right{
    width: 48%;
    float: left;
    height: 30px;
    line-height: 30px;
    margin-bottom: 15px;
    cursor: pointer;
    color: #0090ff;
    border: 1px solid #0090ff;
  }
  .view-header-left{
    clear: right;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }
  .view-header-right{
    clear: right;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }
  .view-header-choose{
    color:#fff;
   background-color:  #0090ff;
  }
  .view-main{
    width:96%;
    margin:0 auto;
  }
  .view-main img{
    margin:165px 32%;
    width: 330px;
    height: 255px;
  }
  button{
    float: right;
    border: 1px solid #55adf8;
    outline: none;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    font-size:16px;
    height:30px;
    line-height: 30px;
    letter-spacing:-0.39px;
    text-align:center;
    margin-right:2%;
    color:#ffffff;
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    margin-bottom: 20px;
    width: 150px;
    cursor: pointer;
  }

  .central-btn-container .data-delete {
    float:none;
    *margin-left:50%;
    background-image: linear-gradient(89deg, #ff3535 1%, #ff5252 100%);
  }

  .central-btn-container {
    text-align: center;
    padding-top:40px;
    margin-top:50px;
    border-top:1px solid #dedede;
  }

  @media screen and (max-width: 1500px){
    .view-main img{
      margin:18% 32%;
      width: 330px;
      height: 255px;
    }
  }
 .view-main2{
   clear: both;
 }
  .main-header-left{
    margin-left: 1.5%;
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    margin-bottom: 15px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }

  .table-container{
    width:100%;
    overflow-y: scroll;
    height:302px;
  }

  .no-data{
    width:100%;
    height:232px;
    clear: left;
  }

  table{
    margin:0 auto;
    width:98%;
    color:#282828;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
  }

  .header{
    height:38px;
    background-color:#cfdff0;
    font-size:15px;
    letter-spacing:-0.37px;
    width: 99%;
    clear: left;
    margin-left: 1%;
  }
  .header table{
    width:100%;
    text-align:center;
  }
  .table-title{
    height:38px;
  }
  .spe-td1{
    width:13%;
  }
  .spe-td2{
    width:11%;
  }
  .spe-td3{
    width:22%;
  }
  .spe-td4{
    width:20%;
  }
  tr{
    height: 50px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }
  .even{
    background:#ebeef1;
  }
  .checkbox{
    width:7%;
  }
  .pdm{
    margin-top: 20px;
  }
  table input{
    width:16px;
    height:16px;
  }
 .checkbox22{
   opacity: 0;
 }
  table label{
    display: inline-block;
    width:17px;
    height:17px;
    background: url("../../assets/checkbox.png") left 1px no-repeat;
    cursor: pointer;
  }
  .checked{
    background: url("../../assets/Select.png") left 0 no-repeat;
  }

  .no-data p{
    margin-top: 20px;
    margin-left:20px;
  }
</style>



// WEBPACK FOOTER //
// dateView.vue?1b8e1199